import {Grid, GridProps} from "@mantine/core";
import {
  TransportMethod,
  StatisticsGroupWrapper,
  statisticsType,
  supportsMethod,
  TransportCategory, transportCategory
} from "@ots-frontend/ots-data";
import {PropsWithChildren} from "react";
import {HasAccess} from "../../auth/HasAccess/HasAccess";
import {StatisticInsight} from "../StatisticInsight/StatisticInsight";
import {useNavigate} from "react-router-dom";

export type InsightsGridProps = Omit<GridProps, 'children'> & {
  insights?: StatisticsGroupWrapper
  rateModels?: string[]
  method?: TransportMethod
  category?: TransportCategory
  loading?: boolean
}

export const InsightsOverviewGrid = (props: PropsWithChildren<InsightsGridProps>) => {
  const {
    insights,
    rateModels,
    method,
    category,
    loading,
    children,
    ...rest
  } = props

  const navigate = useNavigate()

  return (
    <Grid {...rest}>
      {supportsMethod(method, statisticsType.cost) &&
        <HasAccess permissions={["view_cost"]}>
          <Grid.Col span={4}>
            <StatisticInsight
              statistics={insights}
              type={statisticsType.cost}
              method={method}
              rateModels={rateModels}
              category={category}
              loading={loading}/>
          </Grid.Col>
          <Grid.Col span={4}>
            <StatisticInsight
              statistics={insights}
              type={statisticsType.costPerQuantity}
              method={method}
              rateModels={rateModels}
              category={category}
              loading={loading}/>
          </Grid.Col>
        </HasAccess>
      }

      {supportsMethod(method, statisticsType.quantity) &&
        <Grid.Col span={4}>
          <StatisticInsight
            statistics={insights}
            type={statisticsType.quantity}
            method={method}
            rateModels={rateModels}
            category={category}
            loading={loading}
            onSearchClick={() => navigate('/insights/quantity-by')}/>
        </Grid.Col>
      }

      {supportsMethod(method, statisticsType.loads) &&
        <Grid.Col span={4}>
          <StatisticInsight
            statistics={insights}
            type={statisticsType.loads}
            method={method}
            rateModels={rateModels}
            category={category}
            loading={loading}
            onSearchClick={() => navigate('/insights/loads-by')}/>
        </Grid.Col>
      }

      {(category === transportCategory.oil && supportsMethod(method, statisticsType.rejects)) &&
        <Grid.Col span={4}>
          <StatisticInsight
            statistics={insights}
            type={statisticsType.rejects}
            method={method}
            rateModels={rateModels}
            category={category}
            loading={loading}
            color={(value) => value ? "red" : undefined}/>
        </Grid.Col>
      }

      {children}
    </Grid>
  )
}
